import React from 'react';

const PlansSidebar = ({ 
  plans, 
  activeSlug, 
  title, 
  setTitle, 
  sidebarOpen, 
  setSidebarOpen,
  onCreatePlan, 
  onSelectPlan,
  calculateProgress 
}) => {
  return (
    <>
      <button 
        className={`sidebar-toggle ${sidebarOpen ? 'active' : ''}`} 
        onClick={() => setSidebarOpen(!sidebarOpen)} 
        aria-label="Toggle sidebar"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
        <span>Mis Planes</span>
        {plans.length > 0 && <span className="sidebar-badge">{plans.length}</span>}
      </button>

      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}
      
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="sidebar-close" onClick={() => setSidebarOpen(false)} aria-label="Cerrar sidebar">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <h2>Mis Planes</h2>
        <form onSubmit={onCreatePlan} className="new-plan">
          <input 
            value={title} 
            onChange={(e) => setTitle(e.target.value)} 
            placeholder="Nuevo plan" 
          />
          <button type="submit">Crear</button>
        </form>
        {plans.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📋</div>
            <p className="empty-text">No tienes planes aún</p>
            <p className="empty-hint">Crea tu primer plan de negocios arriba</p>
          </div>
        ) : (
          <>
            <div className="plans-list-header">
              <span className="plans-count">{plans.length} {plans.length === 1 ? 'Plan' : 'Planes'}</span>
            </div>
            <ul className="section-list">
              {plans.map(p => {
                const progress = calculateProgress(p);
                const isActive = p.slug === activeSlug;
                const hasActionPlan = p.action_plan_md;
                
                return (
                  <li key={p.slug}>
                    <button 
                      className={`section-btn ${isActive ? 'active-plan' : ''} ${hasActionPlan ? 'has-action-plan' : ''}`}
                      onClick={() => onSelectPlan(p.slug)} 
                      style={{ fontWeight: isActive ? 'bold' : 'normal' }}
                    >
                      <span className="section-status-icon">
                        {hasActionPlan ? '🎯' : (progress === 100 ? '✅' : '📄')}
                      </span>
                      <span className="section-name">{p.title}</span>
                      <span className="plan-progress">{progress}%</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </aside>
    </>
  );
};

export default PlansSidebar;
